import { motion } from "framer-motion";
import { useAuth } from "@/lib/platform/AuthProvider";
import { useAppNavigation } from "@/lib/platform";
import ParticleBackground from "@/components/ux/ParticleBackground";
import { NativeAppInsets } from "../components/ux/NativeAppInsets";
import logoHorizontal from "@/assets/icons/outclose_horizontal.svg";
import logo from "@/assets/icons/outclose.svg";

/**
 * Start page shown to native app users who are not signed in.
 * Displays logo, tagline, and login/quiz buttons.
 */
export default function StartPage() {
  const { navigate } = useAppNavigation();
  const { isSignedIn, openSignIn } = useAuth();

  const handleTakeQuiz = () => {
    navigate("/onboarding");
  };

  const handleLogin = () => {
    openSignIn({
      onSuccess: () => {
        console.log('Navigating due to signin success');
        navigate("/dashboard");
      },
      returnTo: "/dashboard",
    });
  };

  // If user becomes signed in, redirect to dashboard
  if (isSignedIn) {
    console.log('Navigating to dashboard due to isSignedIn');
    navigate("/dashboard");
    return null;
  }

  return (
    <div className="w-full h-dvh min-h-dvh relative flex" >
      <ParticleBackground className="absolute inset-0" />
      <NativeAppInsets>
        <div className="relative h-full w-full flex flex-col px-8 py-10">
          {/* Spacer - flex: 2 */}
          <div className="flex-[2]" />

          {/* Logo section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="flex flex-col items-center"
          >
            {/* Icon with gradient background */}
            <div className="mb-8">
              <img src={logo} alt="" className="w-24 h-24 dark:invert" />
            </div>

            {/* Logo - inverts in dark mode like Flutter version */}
            <img
              src={logoHorizontal}
              alt="Outclose"
              className="w-[280px] h-auto dark:invert"
            />
            
            {/* Tagline */}
            <p className="mt-4 text-lg font-medium text-gray-600 dark:text-gray-400">
              Find your people
            </p>
          </motion.div>

          {/* Spacer - flex: 3 */}
          <div className="flex-[3]" />

          {/* Buttons section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            className="flex flex-col gap-4 max-w-2xl self-center w-full"
          >
            {/* Login - Primary button */}
            <button
              onClick={handleLogin}
              className="w-full h-14 btn btn-secondary"
            >
              Login
            </button>

            {/* Take the Quiz - Secondary/outlined button */}
            <button
              onClick={handleTakeQuiz}
              className="w-full h-14 btn btn-primary"
            >
              Take the Quiz
            </button>
          </motion.div>

          {/* Spacer - flex: 1 */}
          <div className="flex-1" />
        </div>
      </NativeAppInsets>

    </div>
  );
}
